import NavMenu from './nav-menu'
import { MobileNavDropdown } from './mobile-nav-dropdown'
import { useNavigate } from 'react-router-dom'
import { Button } from '@quest-lock/ui/button'
import { appRoutes } from '@/constants'

const Navbar = () => {
  const navigate = useNavigate()

  return (
    <>
      <nav className="bg-background border-shire-dark/20 fixed inset-x-4 top-6 z-50 mx-auto h-20 max-w-screen-xl rounded-full border">
        <div className="mx-auto flex h-full items-center justify-between px-4">
          <div className="flex items-center gap-3">
            <img
              src="/favicon/header-logo.webp"
              className="size-14 cursor-pointer"
              alt="Quest-Lock logo"
              onClick={() => navigate('/')}
            />
            <span className="font-heading text-foreground text-2xl">
              Quest-Lock
            </span>
          </div>
          <NavMenu className="hidden lg:block" />

          <div className="flex items-center gap-3">
            <Button
              className="bg-shire-sun text-shire-dark hover:bg-shire-bark hover:text-shire-light hidden rounded-full lg:inline-flex"
              onClick={() => window.location.assign(appRoutes.authenticator)}
            >
              Get Started
            </Button>
            <div className="lg:hidden">
              <MobileNavDropdown />
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar
